var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.de != null && _vm.de.status)?_c('span',{staticClass:"badge",class:{
      'bg-danger': _vm.de.status == 'NOUVEAU',
      'bg-info': _vm.de.status == 'EN_COURS',
      'bg-primary': _vm.de.status == 'TERMINE',
      'bg-success': _vm.de.status == 'VALIDE',
    }},[_vm._v(" "+_vm._s(_vm.de.categorieDemandeur)+" | "+_vm._s(_vm.de.status.replace("_", " "))+" | "+_vm._s(_vm.de.niveauPriseEnCharge)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }